<div mat-dialog-title>
  <h1>{{'FILE-MANAGER.TABLE.LINK-TITLE' | translate}}</h1>
</div>
<div mat-dialog-content fxLayout="column" [formGroup]="dialogForm">
  <div fxFlex fxLayout="column" class="my-24">
      <input autocomplete="off" fxFlex formControlName="name" placeholder="{{'FILE-MANAGER.TABLE.LINK-NAME' | translate}}" class="border-bottom pl-0 pb-4" maxlength="200">
      <mat-hint>{{dialogForm.value.name.length}} / 200</mat-hint>
  </div>
  <div fxFlex fxLayout="column" class="mb-24">
      <input autocomplete="off" fxFlex formControlName="link" placeholder="{{'FILE-MANAGER.TABLE.LINK-URL' | translate}}" class="border-bottom pl-0 pb-4" maxlength="255">
      <mat-hint>{{dialogForm.value.link.length}} / 255</mat-hint>
  </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end center">
  <button mat-button (click)="onDismiss()">{{'DIALOGS.ACTIONS.CANCEL' | translate}}</button>
  <button mat-raised-button color="accent" (click)="onConfirm()">{{'DIALOGS.ACTIONS.ADD' | translate}}</button>
</div>